import { useCallback } from 'react'
import { useDispatch } from 'react-redux'

import snackbarActions from '../../store/modules/snackbar'

const useSnackbar = ({
  
} = {}) => {
  const dispatch = useDispatch()
  const error = useCallback((message: any) => {
    dispatch(snackbarActions.setError(message))
  }, [])
  const info = useCallback((message: any) => {
    dispatch(snackbarActions.setInfo(message))
  }, [])
  const success = useCallback((message: any) => {
    dispatch(snackbarActions.setSuccess(message))
  }, [])
  return {
    error,
    info,
    success,
  }
}

export default useSnackbar